import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex-grow-1 w-100 h-100",
  ref: "root"
}
const _hoisted_2 = { class: "list-group" }
const _hoisted_3 = {
  key: 0,
  class: "list-group-item border-0 p-0 py-3"
}
const _hoisted_4 = {
  key: 0,
  class: "badge bg-info m-0 mb-2"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LControlLayers = _resolveComponent("LControlLayers")!
  const _component_MapyCzBasicLayer = _resolveComponent("MapyCzBasicLayer")!
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LPopup = _resolveComponent("LPopup")!
  const _component_LMarker = _resolveComponent("LMarker")!
  const _component_LMap = _resolveComponent("LMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.nearViewport)
      ? (_openBlock(), _createBlock(_component_LMap, {
          key: 0,
          zoom: _ctx.zoom,
          center: _ctx.center,
          options: {zoomSnap: 0.25},
          onReady: _ctx.onMapReady,
          ref: "container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LControlLayers, {
              position: "topright",
              onReady: _ctx.onLayersControlReady
            }, null, 8, ["onReady"]),
            (_ctx.viewFitted)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_MapyCzBasicLayer),
                  _createVNode(_component_MapyCzOrthoPhotoLayer, { visible: false })
                ], 64))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markers, (marker, index) => {
              return (_openBlock(), _createBlock(_component_LMarker, {
                key: index,
                icon: _ctx.createIcon(marker),
                "lat-lng": marker.coordinates
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LPopup, {
                    options: {maxHeight: _ctx.maxPopupHeight}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_2, [
                        (marker.pointsToMainEstate)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                              (_ctx.comparedEstates.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Oceňovaná nemovitost"))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: "d-block",
                                innerHTML: _ctx.mainEstate.title
                              }, null, 8, _hoisted_5)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marker.titles, (title) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "list-group-item border-top-0 border-start-0 border-end-0 p-0 m-0 py-3",
                            innerHTML: title
                          }, null, 8, _hoisted_6))
                        }), 256))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["options"])
                ]),
                _: 2
              }, 1032, ["icon", "lat-lng"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["zoom", "center", "onReady"]))
      : _createCommentVNode("", true)
  ], 512))
}